import React from 'react';
import type { DispensaryRiskRating } from '@gcv/shared';
import { Chip } from '@mui/material';

import { dispensary_rating_options_map } from 'domain/consts/dispensary-internal';
import palette from 'ui/theme/palette';

export interface RatingChipProps {
  rating?: DispensaryRiskRating;
  size?: 'small' | 'medium';
  dataCy?: string;
}

const RATING_COLORS: { [rating in DispensaryRiskRating]: { color: string; backgroundColor: string } } = {
  none: { color: palette.text.secondary, backgroundColor: palette.background.secondary },
  low: { color: palette.success.dark, backgroundColor: palette.success.background },
  'low-moderate': { color: palette.info.dark, backgroundColor: palette.info.screen },
  'high-moderate': { color: palette.warning.text, backgroundColor: palette.warning.background },
  high: { color: palette.error.dark, backgroundColor: palette.error.background }
};

export const RatingChip: React.FC<RatingChipProps> = (props) => {
  const rating = props.rating ?? 'none';
  const { color, backgroundColor } = RATING_COLORS[rating];

  return (
    <Chip
      label={dispensary_rating_options_map[rating]}
      variant="outlined"
      size={props.size ?? 'medium'}
      data-cy={props.dataCy ?? `rating-chip-${rating}`}
      sx={{ color, backgroundColor, borderColor: color, fontWeight: 600 }}
    />
  );
};
